import { useExpenseLoaders } from "../../administration/loaders/expenseLoaders"
import { useProductLoaders } from "../../products"
import { usePurchaseLoaders } from "../loaders/purchaseLoaders"

export const useSupplierHooks = () => {
    const productLoaders = useProductLoaders()
    const purchaseLoaders = usePurchaseLoaders()
    const expenseLoaders = useExpenseLoaders()

    const canRemoveSupplier = async (supplierId: string): Promise<boolean> => {
        const { countProducts } = productLoaders()
        const productsCount = await countProducts('supplierId', supplierId)

        const { countPurchases } = purchaseLoaders()
        const purchasesCount = await countPurchases('supplierId', supplierId)

        const { countExpenses } = expenseLoaders()
        const expensesCount = await countExpenses('supplierId', supplierId)
        
        return productsCount === 0 &&
            purchasesCount === 0 &&
            expensesCount === 0
    }

    return {
        canRemoveSupplier
    }
}
